/**
 * @author       kevin.chau@zumper.com (Kevin Chau)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  trackTourBookingEvent.js
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import {
  type CLICK_TOUR_AVAILABILITY,
  type TOUR_BOOKING_SUBMIT_CLICK,
  event,
} from '@zcode-ui/web-zumper-integrations'
import type { Origin } from '@zcode/nr-utils'
import { getRouteProps } from '@zcode/nr/es/shared/packages/history-middleware'
import type { Listable, Property } from '@zcode/state-type'
import { routes } from '@zcode/zumper-routes'
import type { getOneTapTourData } from '../../../components/EqualCTAs/TourButton/getOneTapTourData'
import { getCurrentLocation } from '../../../inspectors/index'
import type { Dispatch, GetState } from '../../types'
import { getDetailEventProps } from './trackDetailEvent'

interface TrackTourBookingSubmitClickProps {
  currentTab?: string
  entity: Listable | Property
  name: typeof TOUR_BOOKING_SUBMIT_CLICK
  oneTap?: boolean
  origin: Origin
  pathname: string
  values: Omit<
    NonNullable<ReturnType<ReturnType<typeof getOneTapTourData>>>['formValues'],
    'floorplanId' | 'moveInDate'
  > & {
    floorplanId: number | null | undefined
    moveInDate: string | null
    saveSearch?: boolean
  }
}

interface TrackClickTourAvailabilityProps {
  entity: Property | null | undefined
  name: typeof CLICK_TOUR_AVAILABILITY
  origin: Origin
}

type TrackTourBookingEventProps = TrackTourBookingSubmitClickProps | TrackClickTourAvailabilityProps

export const trackTourBookingEvent =
  ({ entity, name, ...additionalProps }: TrackTourBookingEventProps) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const { match } = dispatch(getRouteProps({ routes }))

    const user = getUser(state)
    const location = getCurrentLocation(state)

    const detailEventProps = entity ? getDetailEventProps(entity, match, state) : {}
    const props = { ...detailEventProps, ...additionalProps }

    dispatch(event({ name, props, user, location }))
  }
